import { isNode } from "@use/is-node";

/**
 * Internal set used on node.js environments to prevent the same script from
 * being loaded multiple times.
 */
const loadedJs = new Set<string>();

/**
 * Helper that'll make sure that the given JavaScript will be loaded.
 *
 * In a node.js environment, the script will be added to the load-js side
 * effect, so that the script can be flushed along with the rest of the html
 * markup.
 *
 * In browsers, a script will be created and injected directly into the DOM, and
 * a promise will be resolved once the script has been loaded.
 */
export async function loadJs(src: string): Promise<void> {
    // bail out in a node.js based environment
    if (isNode()) {
        return;
    }

    // Import the scriptjs package only in browser environments (it WILL break
    // node.js environments!)
    // tslint:disable-next-line no-require-imports
    const $script = <(path: string, callback: () => void) => void> require("scriptjs");

    // In browsers we're going to rely on scriptjs to actually load the desired
    // scripts
    return new Promise<void>((resolve) => {
        $script(src, resolve);
    });
}
